const gutenberg = {
    toggle: function () {
        window.dispatchEvent(new CustomEvent('ToggleGutenberg', {
            bubbles: true,
            composed: true,
            cancelable: true,
        }))
    },
    open: function () {
        window.dispatchEvent(new CustomEvent('OpenGutenberg', {
            bubbles: true,
            composed: true,
            cancelable: true,
        }))
    },
    close: function () {
        window.dispatchEvent(new CustomEvent('CloseGutenberg', {
            bubbles: true,
            composed: true,
            cancelable: true,
        }))
    },
    recordFooterButtonClicked: function () {
        recordClickStreamEvent({
            name: 'user_clicked_footer_si_button',
        });
    },
    recordHeaderButtonClicked: function () {
        recordClickStreamEvent({
            name: 'user_clicked_header_si_button',
        });
    },
    recordHeroButtonClicked: function () {
        recordClickStreamEvent({
            name: 'user_clicked_hero_si_button',
        });
    },
    recordProductButtonClicked: function () {
        recordClickStreamEvent({
            name: 'user_clicked_product_si_button',
        });
    },
    recordLandingHeroClicked: function () {
        recordClickStreamEvent({
            name: 'user_clicked_landing_hero_si_button',
        });
    },
    recordLandingProductClicked: function () {
        recordClickStreamEvent({
            name: 'user_clicked_landing_product_si_button',
        });
    },
    recordLandingCTAClicked: function () {
        recordClickStreamEvent({
            name: 'user_clicked_landing_cta_si_button',
        });
    },
    recordLandingFooterClicked: function () {
        recordClickStreamEvent({
            name: 'user_clicked_landing_footer_si_button',
        });
    },
};

function recordClickStreamEvent (payload) {
    if (!window.ClickstreamAnalytics) {
        console.warn('ClickstreamAnalytics not loaded.');
        return;
    }

    ClickstreamAnalytics.record(payload);
}
window.gutenberg = gutenberg;
export default gutenberg;